import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b023051"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-description my-4" }
const _hoisted_2 = { class: "buttons larger-action-button mt-6" }

import { useI18n } from 'vue-i18n'
import { ref, onMounted } from 'vue'

import Modal from '@/popup/components/shared/Modal/Modal'
import Button from '@/popup/components/shared/Button.vue'
import {
  Password,
  Error as ErrorComponent,
} from '@/popup/components/shared/Form/Form'

type Properties = {
  onCancel: () => void
  onContinue: (password: string) => Promise<{ passwordCorrect: boolean }>
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RestorePassword',
  props: {
    onCancel: { type: Function },
    onContinue: { type: Function }
  },
  setup(__props: any) {

const { t } = useI18n({ useScope: 'global' })

const props = __props

const password = ref('')
const focus = ref(false)
const incorrectPassword = ref(false)

const onCancel = () => {
  password.value = ''
  props.onCancel()
}

const onContinue = async () => {
  if (password.value === '') {
    return
  }
  const { passwordCorrect } = await props.onContinue(password.value)
  incorrectPassword.value = !passwordCorrect
}

const onUpdate = () => {
  incorrectPassword.value = false
}

onMounted(() => {
  focus.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal).Wrapper, { "extra-class": "wider" }, {
    default: _withCtx(() => [
      _createVNode(_unref(Modal).Background, {
        "extra-class": "darker blurry",
        onClick: onCancel
      }),
      _createVNode(_unref(Modal).Content, { "extra-class": "wider" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Modal).Heading, { "extra-class": "larger" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('modal.restore_wizard.password_modal_title')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("form", {
            class: "password-form",
            onSubmit: _withModifiers(onContinue, ["prevent"])
          }, [
            _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(t)('modal.restore_wizard.password_modal_description')), 1 /* TEXT */),
            _createVNode(_unref(Password), {
              password: password.value,
              "onUpdate:password": [
                _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                onUpdate
              ],
              "show-info": false,
              autofocus: focus.value,
              validators: [],
              "is-bordered": true
            }, null, 8 /* PROPS */, ["password", "autofocus"]),
            (incorrectPassword.value)
              ? (_openBlock(), _createBlock(_unref(ErrorComponent), {
                  key: 0,
                  error: _unref(t)('backend.unlock.incorrect_password')
                }, null, 8 /* PROPS */, ["error"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(Button, {
                variant: "text",
                type: "button",
                onClick: onCancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('qr_code.import_profile.cancel')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(Button, {
                class: "submit",
                variant: "primary",
                "is-full-width": true,
                disabled: !password.value,
                type: "submit",
                onClick: onContinue
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('modal.restore_wizard.continue')), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"])
            ])
          ], 32 /* NEED_HYDRATION */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}
}

})